import { render, staticRenderFns } from "./addxy.vue?vue&type=template&id=97a19de2&scoped=true"
import script from "./addxy.vue?vue&type=script&lang=js"
export * from "./addxy.vue?vue&type=script&lang=js"
import style0 from "./addxy.vue?vue&type=style&index=0&id=97a19de2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a19de2",
  null
  
)

export default component.exports